import { render, staticRenderFns } from "./GameTwitchChapters.vue?vue&type=template&id=23d48f86&"
import script from "./GameTwitchChapters.vue?vue&type=script&lang=js&"
export * from "./GameTwitchChapters.vue?vue&type=script&lang=js&"
import style0 from "./GameTwitchChapters.vue?vue&type=style&index=0&id=23d48f86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports